import { useAccountCompanyId } from 'application/hooks';
import { SBER_PRIME_SLUG, useBillingInfo } from '@entities/billing';
import { useAppSelector } from 'application/providers/StoreProvider';
import { selectIsChangePricePlanAvailable } from 'application/store';

import { OrganizationDiscountStatus } from '@shared/api/graphql/generated';

interface UseRatesTable {
  isChangePricePlanAvailable: boolean;
  isPrimeDiscountAvailable: boolean;
  primeDiscountValue?: number;
}

const useRatesTable = (): UseRatesTable => {
  const isChangePricePlanAvailable = useAppSelector(selectIsChangePricePlanAvailable);

  const companyId = useAccountCompanyId();

  const { discount } = useBillingInfo(companyId);

  const isPrimeDiscountAvailable =
    discount?.slug === SBER_PRIME_SLUG && discount.status === OrganizationDiscountStatus.InProgress;
  const primeDiscountValue = discount?.value;

  return {
    isChangePricePlanAvailable,
    isPrimeDiscountAvailable,
    primeDiscountValue,
  };
};

export default useRatesTable;
